import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';

export default function Header() {
  const features = useSelector((state) => state.config.features);
  const [open, setOpen] = useState(false);

  return (
    <header className="app-header">
      <div className="wrap header-row">
        <Link to="/" className="brand" onClick={() => setOpen(false)}>
          <span className="brand-mark">LBI</span>
          <span className="brand-word">Local</span>
        </Link>

        <button
          type="button"
          className="nav-toggle"
          aria-expanded={open}
          aria-label="Menu"
          onClick={() => setOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>

        <nav className={open ? 'nav nav-open' : 'nav'} onClick={() => setOpen(false)}>
          {features.directory && <NavLink to="/directory">Directory</NavLink>}
          {features.events && <NavLink to="/events">Events</NavLink>}
          {features.beaches && <NavLink to="/beaches">Beaches</NavLink>}
          {features.concierge && <NavLink to="/concierge">Concierge</NavLink>}
          {features.directory && (
            <NavLink to="/submit" className="nav-cta">
              Add a listing
            </NavLink>
          )}
        </nav>
      </div>
    </header>
  );
}
